// import _ from 'lodash';
import $ from 'jquery';
import config from 'store/_config';
import { ActionCreators } from 'redux-undo';
const opentype = require('opentype.js');
import { axiosInstance as axios, handleAxiosErrors, isInGodMode } from '_utils';
import uniqid from 'uniqid';
import { saveAs } from 'file-saver';
import {
    changeCanvasFillColour,
    setupCanvases,
    resetCanvases,
    removeCanvasLayer,
    addCanvasLayer,
    cancelCanvasLayer,
    toggleCanvasRegions,
    changeCanvasRegionStyle,
    changeCanvasLayerField,
    selectCanvasLayer,
    saveCanvasLayer,
    getCanvasWidth,
    adjustImageScalingOnUpload,
} from '../actions/canvasActions';
import {
    checkIfActiveColourIsBlack,
    getLayerErrorMessage,
    getLayerExtendedData,
    getPreset,
    getTagData,
} from '../selectors/defaultSelectors';
import { displayRecommendedProducts } from '../dom/cart';
import {
    readTagCart,
    setDefaultTagUsage,
    toggleLoading as toggleTagWizardLoading,
} from './tagWizardActions';
import { createAlert } from '../dom/window';

import {
    getAvailableTagUsage,
    getFinalisedTagTypeLayout,
    getSelectedProduct,
} from '../selectors/tagWizardSelector';
import { generateZeros } from '../_utils';
import copy from 'copy-to-clipboard';

export const EMPTY_TAG_DATA = {
    printingOffset: {},
    sides: {},
    regions: {},
    styles: {},
    layers: {},
};

// create
export const createTagLayers = (style, layerTypes) => {
    return style.layers
        ? style.layers.reduce((newLayers, layer) => {
              const id = uniqid('layer-');
              const firstType = 'initialvalues';

              const newLayer = {
                  ...layer,
                  id: id,
                  display: 0,
                  font: layer.font || '1',
                  // fontSize: 64,
                  fontSize: layer.fontSize || 64,
                  fontSpacing: layer.fontSpacing || 0,
                  textOrientation: layer.textOrientation || 'up',
                  textAlignment: 'center',
                  activeType: firstType,
                  side: style.side,
                  region: style.region,
                  style: style.id,
                  errors: false,
                  types: layer.types.reduce((auxTypes, type) => {
                      auxTypes = {
                          ...auxTypes,
                          [type]: layerTypes[type],
                      };
                      return auxTypes;
                  }, {}),
              };
              return {
                  ...newLayers,
                  [id]: newLayer,
              };
          }, {})
        : false;
};
export const createTagStyles = (region, styleTypes) => {
    return region.styles
        ? region.styles.reduce((newStyles, style) => {
              const id = uniqid('style-');
              return {
                  ...newStyles,
                  [id]: {
                      ...styleTypes[style],
                      side: region.side,
                      region: region.id,
                      id: id,
                  },
              };
          }, {})
        : false;
};
export const removeTagStyle = (region, style) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'REMOVE_TAG_STYLE',
            region: region,
            style: style,
        });
    };
};
export const createTagRegions = (side, regionTypes) => {
    return side.regions.reduce((newRegions, region) => {
        const id = uniqid('region-');
        return {
            ...newRegions,
            [id]: {
                ...regionTypes[region],
                side: side.id,
                id: id,
            },
        };
    }, {});
};
export const createTagData = (tag) => {
    console.log('tagdata',tag)
    const { type, group } = tag;
    const {
        batch,
        sides,
        regions,
        styles,
        layers,
        variationImages,
        itemIncluded,
    } = type;
    let tagSides = {};
    let tagRegions = {};
    let tagStyles = {};
    let tagLayers = {};

    tagSides = sides
        ? Object.values(sides).reduce((newSides, side) => {
              const newRegions = createTagRegions(side, regions);
              tagRegions = {
                  ...tagRegions,
                  ...newRegions,
              };
              return {
                  ...newSides,
                  [side.id]: {
                      ...side,
                      active: true,
                      regions: Object.keys(newRegions),
                  },
              };
          }, {})
        : false;
    tagRegions = tagRegions
        ? Object.values(tagRegions).reduce((newRegions, region) => {
              const newStyles = createTagStyles(region, styles);
              tagStyles = {
                  ...tagStyles,
                  ...newStyles,
              };
              return {
                  ...newRegions,
                  [region.id]: {
                      ...region,
                      active: true,
                      activeStyle: Object.keys(newStyles)[0],
                      styles: newStyles ? Object.keys(newStyles) : false,
                  },
              };
          }, {})
        : false;
    tagStyles = tagStyles
        ? Object.values(tagStyles).reduce((newStyles, style) => {
              const newLayers = createTagLayers(style, layers);
              tagLayers = {
                  ...tagLayers,
                  ...newLayers,
              };
              return {
                  ...newStyles,
                  [style.id]: {
                      ...style,
                      layers: newLayers ? Object.keys(newLayers) : false,
                  },
              };
          }, {})
        : false;

    return {
        batchCount: batch,
        group: group,
        sides: tagSides,
        regions: tagRegions,
        styles: tagStyles,
        layers: tagLayers,
        variationImages: variationImages,
        itemIncluded: itemIncluded,
    };
};

// set
export const setTagDetails = (data) => {
    return (dispatch, getState) => {
        const store = getState();
        const product = getSelectedProduct(store.tagWizard.present);

        if (product && typeof product.InternalItemID != 'undefined') {
            data = {
                ...data,
                name: product.Title,
                sku: product.InternalItemID,
                minOrder: product.MinOrderQuantity,
                description: product.Content,
            };
        }

        dispatch(ActionCreators.clearHistory());
        dispatch({
            type: 'SET_TAG_DETAILS',
            data: data,
        });
    };
};
export const setTagType = (data) => {
    return (dispatch, getState) => {
        dispatch(ActionCreators.clearHistory());
        dispatch({
            type: 'SET_TAG_TYPE',
            data: data,
        });
    };
};
export const setTagData = (data, ignoredFields = []) => {
    return (dispatch, getState) => {
        let newData = { ...data };
        if (ignoredFields.length) {
            ignoredFields.forEach((field) => {
                if (typeof newData[field] != 'undefined') {
                    delete newData[field];
                }
            });
        }

        return Promise.all([
            dispatch(loadFontsBasedOnData(newData))
        ]).then(() => {
            dispatch(ActionCreators.clearHistory());
            dispatch({
                type: 'SET_TAG_DATA',
                data: newData,
            });
        }).then(() => {
            // Reverse the side if needed
            const state = getState();
            const { sides, printSide, revealBackSideBool } = state.editor.present;

            const hasFrontSide = sides && Object.values(sides).some(side => side.id === 'front' );
            const hasBackSide = sides && Object.values(sides).some(side => side.id === 'back' );

            if(printSide === 'Front' && !hasFrontSide && hasBackSide) {
                dispatch(togglePrintSides('Back'));

                // if(revealBackSideBool === false) {
                //     dispatch(revealBackSide());
                // }
            }
            else if(printSide === 'Back' && hasFrontSide && !hasBackSide) {
                dispatch(togglePrintSides('Front'));

                // if(revealBackSideBool === true) {
                //     dispatch(revealBackSide());
                // }
            }
        });
    };
};
export const setBaseTagData = (key, data) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'SET_BASE_TAG_DATA',
            key: key,
            data: data,
        });
    };
};

// selections
export const cancelLayer = (params) => {
    return (dispatch, getState) => {
        dispatch(ActionCreators.undo());
        dispatch(cancelCanvasLayer(params));
    };
};
export const saveLayer = (layer) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'SELECT_LAYER',
            layer: false,
        });
        dispatch(saveCanvasLayer(layer));
    };
};
export const selectLayer = (layer) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'SELECT_LAYER',
            layer: layer,
        });
        dispatch(selectCanvasLayer(layer));
    };
};

// add
export const addLayer = (style) => {
    return (dispatch, getState) => {
        const { editor, tag } = getState();
        const { styles } = editor.present;
        const { type } = tag;
        const newLayer = createTagLayers(
            {
                ...styles[style],
                layers: type?.styles['custom'].layers,
            },
            type.layers
        );
        dispatch({
            type: 'ADD_LAYER',
            style: style,
            layer: newLayer,
        });
        dispatch(addCanvasLayer(newLayer));
    };
};
export const removeLayer = (layer) => {
    return (dispatch, getState) => {
        dispatch(removeCanvasLayer(layer));
        dispatch({
            type: 'REMOVE_LAYER',
            layer: layer,
        });
    };
};

// change
export const changeTagType = (type) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'CHANGE_TAG_TYPE',
            value: type,
        });

        Promise.all([
            dispatch(toggleEditorLoading(true)),
            dispatch(loadTagType(type)),
        ]).then(() => {
            const { tag } = getState();
            const tagData = createTagData(tag);
            dispatch(resetCanvases());
            dispatch(setTagData(tagData))
        }).then(() => {
            dispatch(setupCanvases());
            dispatch(toggleEditorLoading(false));
        });
    };
};
export const changeLayerScale = (layer, scale, redraw = false) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'CHANGE_LAYER_SCALE',
            layer: layer,
            scale: scale,
        });

        if(redraw) {
            dispatch(changeCanvasLayerField({layer}));
        }
    };
};
export const changeLayerMaxWidth = (layer, maxWidth = null, redraw = false) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'CHANGE_LAYER_MAX_WIDTH',
            layer: layer,
            maxWidth: maxWidth,
        });

        if(redraw) {
            dispatch(changeCanvasLayerField({layer}));
        }
    };
};
export const changeLayerExtraSettings = (layer, params = null, redraw = false) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'CHANGE_LAYER_EXTRA_SETTINGS',
            layer: layer,
            params: params,
        });

        if(redraw) {
            dispatch(changeCanvasLayerField({layer}));
        }
    };
};

export const changeLayerRotation = (layer, rotation) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'CHANGE_LAYER_ROTATION',
            layer: layer,
            rotation: rotation,
        });
        dispatch(changeCanvasLayerField({ layer, target: 'rotation' })); // update the canvas view
    };
};

export const changeLayerTextOrientation = (layer, textOrientation) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'CHANGE_LAYER_TEXTORIENTATION',
            layer: layer,
            textOrientation: textOrientation,
        });
        dispatch(changeCanvasLayerField({ layer })); // update the canvas view
    };
};

export const changeLayerPosition = (layer, position) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'CHANGE_LAYER_POSITION',
            layer: layer,
            position: position,
        });
        dispatch(changeCanvasLayerField({ layer }));
    };
};
export const changeLayerFont = (params) => {
    return (dispatch, getState) => {
        const { value } = params;

        Promise.all([
            dispatch(loadFonts({ fontIDs: [value] }))
        ]).then(() => {
            dispatch(changeLayerField(params));
        });
    };
};
export const changeLayerActiveType = (params) => {
    return (dispatch, getState) => {
        const { value } = params;

        Promise.all([
            dispatch(changeLayerField(params))
        ]).then(() => {
            dispatch(changeLayerBasedOnPreset(params));

            if(value == 'code') {
                dispatch(setDefaultBarcode(params));
            }
        });
    };
};
export const changeLayerField = (params) => {
    return (dispatch, getState) => {
        const { target } = params;

        dispatch({
            type: 'CHANGE_LAYER_FIELD',
            ...params,
        });
        dispatch(changeCanvasLayerField(params));
    };
};
export const removeLayerType = (layer, layerType) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'REMOVE_LAYER_TYPE',
            layer: layer,
            target: layerType,
        });
    };
};
export const addLayerType = (layer, tagTypeKey, tagType) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'ADD_LAYER_TYPE',
            layer: layer,
            tagTypeKey: tagTypeKey,
            tagType: tagType,
        });
    };
};
export const changeLayerBasedOnPreset = (params) => {
    return (dispatch, getState) => {
        const { layer } = params;
        const editorState =  getState().editor.present;
        const { layers } = editorState;
        const selectedLayer = layers[layer];

        if (selectedLayer) {
            const preset = getPreset(selectedLayer);
            if(preset) {
                const { forcedPosition, forcedScale, forcedLayerMaxWidth, forcedFont, forcedFontSize, forcedFontSpacing } = preset;

                if (forcedScale) {
                    dispatch(changeLayerScale(layer, forcedScale));
                }
                if (forcedPosition) {
                    dispatch(changeLayerPosition(layer, forcedPosition));
                }
                if (forcedLayerMaxWidth) {
                    dispatch(changeLayerMaxWidth(layer, forcedLayerMaxWidth));
                }
                if (forcedFont) {
                    dispatch(changeLayerFont({
                        layer: layer,
                        target: 'font',
                        value: forcedFont,
                    }));
                }
                if (forcedFontSize) {
                    dispatch(changeLayerFontSize({
                        layer: layer,
                        target: 'fontSize',
                        value: forcedFontSize,
                    }));
                }
                if (forcedFontSpacing) {
                    dispatch(changeLayerFontSize({
                        layer: layer,
                        target: 'fontSpacing',
                        value: forcedFontSpacing,
                    }));
                }
            }
        }
    };
};
export const setDefaultBarcode = (params) => {
    return (dispatch, getState) => {
        const { layer } = params;

        const editorState =  getState().editor.present;

        const { layers } = editorState;
        const selectedLayer = layers[layer];

        if (selectedLayer && (typeof selectedLayer.barcode == 'undefined' || selectedLayer.barcode == '')) {
            dispatch(changeBarcodeType(layer, 'code128'));
        }
    };
};
export const changeBarcodeType = (layer, barcodeType) => {
    return (dispatch, getState) => {
        dispatch(changeLayerField({
            layer: layer,
            target: 'barcode',
            value: barcodeType,
        }));

        dispatch(changeLayerScale(layer, { x: 1, y: 1 }, true));
    };
};
export const changeLayerTypeField = (params) => {
    return (dispatch, getState) => {
        const { layer, target, value } = params;

        if (target == 'completeStartingNumber') {
            if (value.length <= 15) {
                dispatch({
                    type: 'CHANGE_LAYER_TYPE_FIELD',
                    ...params,
                });

                // Change leading zeros
                dispatch({
                    type: 'CHANGE_LAYER_TYPE_FIELD',
                    layer: layer,
                    target: 'leadingZeros',
                    value: generateZeros(value),
                });

                // Change start
                dispatch({
                    type: 'CHANGE_LAYER_TYPE_FIELD',
                    layer: layer,
                    target: 'start',
                    value: value == '' || isNaN(value) ? '' : Number(value),
                });
            }
        } else {
            dispatch({
                type: 'CHANGE_LAYER_TYPE_FIELD',
                ...params,
            });
        }

        dispatch(changeCanvasLayerField(params));
    };
};
export const changeRegionStyle = (params) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'CHANGE_REGION_STYLE',
            ...params,
        });
        dispatch(changeCanvasRegionStyle(params));
        dispatch(resetCanvases());
        dispatch(setupCanvases());
    };
};
export const changeLayerFontSize = (params) => {
    return (dispatch, getState) => {
        dispatch(changeLayerScale(params.layer, { x: 1, y: 1 }));
        dispatch(changeLayerField(params));
    };
};
export const changeColour = (tagColour) => {
    return (dispatch, getState) => {
        const isBlack = checkIfActiveColourIsBlack(tagColour);
        const textColour = isBlack ? 'white' : 'black';

        dispatch({
            type: 'CHANGE_TAG_COLOUR',
            tagColour: tagColour,
            textColour: textColour,
        });
        dispatch(changeCanvasFillColour());
    };
};

export const changeFontColour = (tagColour, FontColourCode) => {
    return (dispatch, getState) => {
        // const isBlack = checkIfActiveColourIsBlack(tagColour);
        // const textColour = isBlack ? 'white' : 'black';
        const textColour =
            FontColourCode && FontColourCode !== ''
                ? FontColourCode
                : '#53565A';

        dispatch({
            type: 'CHANGE_FONT_COLOUR',
            tagColour: tagColour,
            textColour: textColour,
        });
        dispatch(changeCanvasFillColour());
    };
};

export const changeQty = (value) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'UPDATE_EDITOR',
            target: 'qty',
            value: value,
        });
    };
};

// toggle
export const checkIfCanToggleSides = (sides, target) => {
    let availableSides = 0;
    Object.values(sides).map((side) => {
        if (side.id !== target && side.active) {
            availableSides++;
        }
    });
    return availableSides > 0;
};
export const toggleEditorLoading = (value) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'TOGGLE_EDITOR_LOADING',
            value: value,
        });
    };
};
export const toggleSides = (value) => {
    return (dispatch, getState) => {
        const { sides } = getState().editor.present;
        const canToggle = checkIfCanToggleSides(sides, value);

        if (!canToggle) return;

        dispatch({
            type: 'TOGGLE_SIDES',
            side: value,
        });
    };
};

export const togglePrintSides = (value) => {
    return (dispatch, getState) => {
        //  const { sides } = getState().editor.present;
        // const canToggle = checkIfCanToggleSides(sides, value);

        // if (!canToggle) return;

        dispatch({
            type: 'TOGGLE_PRINTSIDES',
            side: value,
        });
        dispatch(resetCanvases());
        dispatch(setupCanvases());

        //dispatch(changeCanvasRegionStyle(params));
        // dispatch(toggleCanvasRegions(region));
    };
};

export const setPrintSide = (value) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'SET_PRINT_SIDE',
            side: value,
        });

        dispatch(resetCanvases());
        dispatch(setupCanvases());
    };
};

export const revealBackSide = () => {
    return (dispatch, getState) => {
        //  const { sides } = getState().editor.present;
        // const canToggle = checkIfCanToggleSides(sides, value);

        // if (!canToggle) return;

        dispatch({
            type: 'REVEAL_BACKSIDE',
        });
        dispatch(resetCanvases());
        dispatch(setupCanvases());

        //dispatch(changeCanvasRegionStyle(params));
        // dispatch(toggleCanvasRegions(region));
    };
};

export const deletePrintSide = (value) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'DELETE_PRTINTSIDE',
            side: value,
        });
        dispatch(resetCanvases());
        dispatch(setupCanvases());
    };
};

export const toggleRegions = (region) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'TOGGLE_REGIONS',
            region: region,
        });
        dispatch(toggleCanvasRegions(region));
    };
};
export const toggleLayerError = (params) => {
    return (dispatch, getState) => {
        const { layer, target, value } = params;
        const message = getLayerErrorMessage(target, value);
        if (value) {
            dispatch({
                type: 'ADD_LAYER_ERROR',
                layer: layer,
                target: target,
                message: message,
            });
        } else {
            dispatch({
                type: 'REMOVE_LAYER_ERROR',
                layer: layer,
                target: target,
            });
        }
    };
};

// others
/**
 * Helper function to load fonts
 *
 * @param params
 * @returns {function(*=, *): Promise<unknown[]>}
 */
export const loadFonts = (params) => {
    return (dispatch, getState) => {
        const { fontIDs = [] } = params;

        const { editor } = getState();
        const { fonts } = editor.present;
        let fontLoadPromise = [];

        Object.entries(fonts).map(([id, item]) => {
            let initialCheck = (fontIDs.length == 0 || (fontIDs.length > 0 && fontIDs.some(fontID => fontID == id)));

            if(initialCheck && typeof(item.curves) == 'undefined') {
                fontLoadPromise.push(new Promise((resolve, reject) => {
                    return opentype.load(item.url, (error, font) => {
                        dispatch(saveFont({id, font}));
                        resolve();
                    });
                }));
            }
        });

        return Promise.all(fontLoadPromise);
    };
};
/**
 * Request required fonts based on tag data
 *
 * @param data
 * @returns {Function}
 */
export const loadFontsBasedOnData = (data) => {
    return (dispatch) => {
        const { layers } = data;

        let fontList = {};
        Object.entries(layers).map(([id, layer]) => {
            const { font } = layer;

            fontList[font] = font;
        });

        const requestedFonts = Object.keys(fontList);

        if(requestedFonts.length > 0) {
            dispatch(toggleEditorLoading(true));

            return Promise.all([
                dispatch(loadFonts({ fontIDs: requestedFonts }))
            ]).finally(() => {
                dispatch(toggleEditorLoading(false));
            });
        }
    };
};
export const loadTagData = () => {
    return (dispatch, getState) => {
        const url = document.getElementById('editor').getAttribute('data-tag');

        // NOTE: this is for the tag generation script
        if (window.tagData) {
            dispatch(setTagData(window.tagData));
            return;
        }

        if (!url) return;
        return axios
            .get(url, {
                withCredentials: true,
            })
            .then((response) => {
                // console.log(response.data);
                // console.log(typeof response.data);
                dispatch(setTagData(response.data));
            })
            .catch((error) => handleAxiosErrors(error));
    };
};
export const axiosRequestTagType = (codeTagFamily) => {
    let { url, query } = config.tags.getTypeCMS;
    query = query.replace(
        /{params}/,
        `CodeTagFamily: "${codeTagFamily.toUpperCase()}"`
    );

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};
export const axiosRequestLayouts = (codeTagFamily, type) => {
    let { url, query } = config.tags.getLayouts;

    let data = {
        query: query,
        variables: {},
    };

    if(codeTagFamily) {
        data.variables.CodeTagFamily = codeTagFamily.toUpperCase();
    }
    if(type) {
        data.variables.TagType = type;
    }

    return axios.post(url, data, {
        withCredentials: true,
    });
};
export const loadBaseTagData = () => {
    return (dispatch, getState) => {
        const codeTagFamily =
            document.getElementById('editor').getAttribute('data-tag-type') ||
            false;

        if (!codeTagFamily) return;

        console.log('Loading Base Tag Data for:', codeTagFamily);

        // Helper function to request
        const request = (type, requestedBackendType = null) => {
            if (!requestedBackendType) {
                requestedBackendType = type;
            }

            const backendType = getFinalisedTagTypeLayout(requestedBackendType);

            return axiosRequestLayouts(codeTagFamily, backendType)
                .then((response) => {
                    const layoutData = response.data.data.readTagLayouts;
                    if (
                        layoutData != null &&
                        layoutData.edges &&
                        layoutData.edges.length > 0
                    ) {
                        const encodedBaseData = layoutData.edges[0].node.EncodedJSONData;
                        dispatch(setBaseTagData(type, JSON.parse(window.decodeJsonFromBase64(encodedBaseData))));
                    } else {
                        createAlert(
                            {
                                message: `Invalid JSON Data on Tag Editor for type: ${type} (${codeTagFamily}). Creating a default one`,
                            },
                            'error'
                        );

                        // Oh no, can't find any, let's create it ourselves then
                        const { tag } = getState();
                        const tagData = createTagData(tag);
                        dispatch(setBaseTagData(type, tagData));
                    }
                })
                .catch((error) => handleAxiosErrors(error));
        };

        const store = getState();
        const selectedProduct = getSelectedProduct(store.tagWizard.present);
        const availableTagUsage = getAvailableTagUsage(
            store.tagWizard.present,
            store
        );
        const { CustomTag, IsNLIS } = availableTagUsage;

        let promiseHolder = [];

        if (CustomTag) {
            console.log('> Custom Tag Editor');
            promiseHolder.push(request('editor'));
        }

        return Promise.all(promiseHolder);
    };
};
export const loadTagDetails = () => {
    return (dispatch, getState) => {
        const sku = document
            .getElementById('editor')
            .getAttribute('data-tag-sku');
        const url = sku;

        if (!url) return;
        return axios
            .get(url, {
                withCredentials: true,
            })
            .then((response) => {
                dispatch(setTagDetails(response.data));
            })
            .catch((error) => handleAxiosErrors(error));
    };
};
export const loadTagTypeCMS = () => {
    return (dispatch, getState) => {
        const sku =
            document.getElementById('editor').getAttribute('data-tag-type') ||
            false;

        if (!sku) return;

        return axiosRequestTagType(sku)
            .then((response) => {
                console.log(response);
                console.log('Setting up Tag Type from CMS');
                try {
                    const list = response.data.data.readTagTypeJSONDatas.edges;
                    if (list.length) {
                        let details = window.decodeJsonFromBase64(list[0].node.EncodedConfiguration);

                        if (typeof details === 'string') {
                            details = JSON.parse(details);
                        }

                        dispatch(setTagType(details));
                    } else {
                        throw new Error(`No Tag Type found for: ${sku}`);
                    }
                } catch (error) {
                    console.log(error);
                    createAlert({
                        message: 'Invalid Tag Type with error: ' + error,
                    });
                }
            })
            .catch((error) => handleAxiosErrors(error));
    };
};
export const loadTagType = (type) => {
    return (dispatch, getState) => {
        const url = type;
        if (!url) return;
        return axios
            .get(url, {
                withCredentials: true,
            })
            .then((response) => {
                dispatch(setTagType(response.data));
            })
            .catch((error) => handleAxiosErrors(error));
    };
};
export const saveFont = (params) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'SAVE_FONT',
            ...params,
        });
    };
};
export const triggerEditorLoaded = (params) => {
    return (dispatch, getState) => {
        const { editor, tagWizard } = getState();
        const { canvas, fonts } = editor.present;
        const data = getTagData(editor.present, tagWizard.present);
        const event = new CustomEvent('editorLoaded', {
            detail: {
                data: data,
                fonts: Object.entries(fonts).reduce((aux, [key, item]) => {
                    return {
                        ...aux,
                        [key]: {
                            value: item.value,
                            label: item.label,
                            url: item.url,
                            //curves: item.curves
                        },
                    };
                }, {}),
                scopes: Object.entries(canvas).reduce((aux, [key, item]) => {
                    return {
                        ...aux,
                        [key]: {
                            width: getCanvasWidth(),
                            height: getCanvasWidth(),
                            // width: item.project.view.bounds.width,
                            // height: item.project.view.bounds.height,
                        },
                    };
                }, {}),
            },
        });

        window.dispatchEvent(event);
        console.log('triggerEditorLoaded fired!');
    };
};
export const setupEditor = (params) => {
    return (dispatch, getState) => {
        const type = document
            .getElementById('editor')
            .getAttribute('data-tag-type');

        return Promise.all([
            dispatch(toggleEditorLoading(true)),
            dispatch(toggleTagWizardLoading(true)),
            dispatch(loadFonts({ fontIDs: [1,2,3,4] })),
            // dispatch(loadTagType(type)),
            dispatch(loadTagTypeCMS(type)),
            // dispatch(loadBaseTagData()),

            dispatch(loadTagDetails()),
        ]).then(() => {
            // Load Base Tag Data
            return Promise.all([
                dispatch(loadBaseTagData()),
            ]);
        }).then(() => {
            const { tag } = getState();

            // This is used on printing
            if (typeof window.tagData != 'undefined') {
                const tagData = window.tagData || createTagData(tag);
                return Promise.all([
                    dispatch(setTagData(tagData))
                ]).then(() => {
                    dispatch(setupCanvases());
                });
            } else {
                return Promise.all([
                    // Set default tag usage that will be used
                    dispatch(setDefaultTagUsage()),
                    // dispatch(loadTagData()),
                ]).then(() => {
                    return dispatch(readTagCart());
                });
            }
        }).then(() => {
            dispatch(toggleEditorLoading(false));
            dispatch(toggleTagWizardLoading(false));
        }).finally(() => {
            dispatch(triggerEditorLoaded());
        });
    };
};
export const uploadFile = (params) => {
    return (dispatch, getState) => {
        const { accepted, layer } = params;
        // start: cursor change to progress
        document.body.style.cursor = 'default';
        document.body.style.cursor = 'progress';
        accepted.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                const fileAsBinaryString = reader.result;

                Promise.all([
                    dispatch(changeLayerTypeField({
                        layer: layer,
                        target: 'name',
                        value: file.name,
                    })),
                    dispatch(changeLayerTypeField({
                        layer: layer,
                        target: 'image',
                        value: fileAsBinaryString,
                    })),
                ]).then(() => {
                    dispatch(adjustImageScalingOnUpload(layer));
                });

            };
            reader.onloadend = () => {
                // end: cursor change to default
                document.body.style.cursor = 'default';
            };
            reader.onabort = () => console.log('file reading was aborted');
            reader.onerror = () => console.log('file reading has failed');
            reader.readAsBinaryString(file);
        });
    };
};

export const clearUploadedFile = (params) => {
    return (dispatch) => {
        const { layer } = params;
        dispatch(
            changeLayerTypeField({ layer: layer, target: 'name', value: null })
        );
        dispatch(
            changeLayerTypeField({ layer: layer, target: 'image', value: null })
        );
    };
};
export const getExportedJSONData = (state) => {
    const { editor, tag, tagWizard } = state;
    const { type, group, sku } = tag;
    const product = getSelectedProduct(tagWizard.present);
    const {
        printingOffset,
        activeColour,
        sides,
        regions,
        styles,
        layers,
        // revealBackSideBool,
    } = editor.present;
    const { cartQty } = tagWizard.present.userInput;
    const { batchCount } = type;
    const data = {
        printingOffset,
        cartQty,
        batchCount,
        group: product.CodeTagFamily || group,
        sku: product.InternalItemID || sku,
        activeColour,
        sides,
        regions,
        styles,
        layers,
        // Work around at the moment. We will remove this later
        revealBackSideBool: Object.values(sides).some((side) => side.id === 'back' && side.active),
    };

    return data;
};
export const onBeforeExportJSONData = (raw) => {
    const data = JSON.parse(raw);

    const newData = {
        ...data,
        layers: Object.entries(data.layers).reduce((newLayers, [layerID, layer]) => {
            let newLayer = {...layer};
            const { activeType, types } = layer;

            if(activeType == 'sequence') {
                const { fields } = types[activeType];
                const { start } = fields;

                // this is our magic word
                if(start == 99999) {
                    let newFields = {
                        ...fields,
                        start: "[[REPLACE_START]]",
                        leadingZeros: "[[REPLACE_LEADINGZEROS]]",
                    };

                    if (typeof (newFields.completeStartingNumber) != 'undefined') {
                        delete newFields.completeStartingNumber;
                    }

                    newLayer.types[activeType].fields = newFields;
                }
            }

            newLayers[layerID] = newLayer;

            return newLayers;
        }, {})
    };

    return JSON.stringify(newData);
};
export const exportJSON = (params = {}) => {
    return (dispatch, getState) => {
        const state = getState();
        const { group } = state.tag;
        const { isCopy = false } = params || {};

        const presentTagWizardState = state.tagWizard.present;
        const product = getSelectedProduct(presentTagWizardState);

        const fileName = product ? product.InternalItemID : group;
        let blob = JSON.stringify(getExportedJSONData(state));

        // TODO: remove the true when going live
        if(isInGodMode() || true) {
            blob = onBeforeExportJSONData(blob);
        }

        if(isCopy) {
            copy(blob);
        }
        else {
            const jsonFile = new Blob(
                [blob],
                {
                    type: 'application/json',
                }
            );

            saveAs(jsonFile, `${fileName}.json`);
        }
    };
};
export const exportSVGs = (editorState) => {
    let svgs = {};
    const { canvas, sides } = editorState;

    Object.entries(canvas).forEach(([region, scope]) => {
        if(sides[region] !== undefined && sides[region].active) {
            // console.log('scope', scope);
            // console.log('scope.project', scope.project);
            svgs[region] = scope.project.exportSVG({
                bounds: 'view',
                asString: true,
            });
        }
    });

    return svgs;
};
export const exportData = (params) => {
    return (dispatch, getState) => {
        return Promise.all([
            dispatch(toggleEditorLoading(true)),
            dispatch(exportJSON(params)),
        ]).then(() => {
            dispatch(toggleEditorLoading(false));
        });
    };
};
export const addToCart = (params) => {
    return (dispatch, getState) => {
        displayRecommendedProducts();
    };
};
export const focusContentField = () => {
    // focus on content field
    setTimeout(function() {
        const $contentField = $('.editorDetails__container [name=content]');
        if ($contentField.length) {
            $contentField.focus();
        }
    }, 100);
};
export const resetTagData = (newType) => {
    return (dispatch, getState) => {
        if (newType == 'editor') {
            const state = getState();
            const baseData = state.editor.present.baseData;

            dispatch(setTagData(baseData[newType]));
        }
        else if(newType == 'nlis' || newType == 'nait') {
            dispatch(setTagData(EMPTY_TAG_DATA));
        }
    };
};

export const changeCurrentSideMask = (newMask) => {
    return (dispatch, getState) => {
        const state = getState();
        const { sides, printSide } = state.editor.present;

        // Get current side
        let currentSideID = '';
        Object.entries(sides).forEach(([sideID, side]) => {
            const { name } = side;

            if(name == printSide) {
                currentSideID = sideID;
            }
        });

        if(currentSideID) {
            dispatch({
                type: 'CHANGE_SIDE_MASK',
                side: currentSideID,
                clippingMask: newMask,
            });
        }
    };
};
